import { useState } from "react";
import { Award, HandHeart } from "lucide-react";
import { MemberAvatar } from "@/components/red/MemberAvatar";
import { IntroRequestSheet } from "@/components/red/IntroRequestSheet";

const initials = (n) => (n || "?").split(" ").slice(0, 2).map((p) => p[0]).join("").toUpperCase();

export const ResultCard = ({ r, servicio, ciudad, necesidad }) => {
  const [open, setOpen] = useState(false);
  const d = r.dueno;
  const lvl = d.nivel_respuesta;
  const lvlText = lvl.etiqueta === "Nuevo" ? "Nuevo" : `${lvl.horas != null ? `Responde en ~${Math.round(lvl.horas)} h · ` : ""}${lvl.porcentaje}% atendidas`;
  return (
    <div data-testid="buscar-result-card" className="c-card p-4 space-y-2.5">
      <p data-testid="buscar-result-headline" className="text-sm font-semibold c-accent">{d.nombre_publico} sí tiene ese contacto.</p>
      <div className="flex items-center gap-3">
        <MemberAvatar m={{ iniciales: initials(d.nombre_publico) }} />
        <div className="min-w-0 flex-1">
          <p className="font-semibold truncate flex items-center gap-1.5">{d.nombre_publico}
            {d.es_fundador && <span data-testid="buscar-result-founder" className="inline-flex items-center gap-0.5 text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-[#bc9538]/15 text-[#9a7622] border border-[#bc9538]/40"><Award className="w-3 h-3" /> #{d.numero_fundador}</span>}
          </p>
          <p data-testid="buscar-result-summary" className="text-sm c-text-2">tiene {r.cantidad} contacto{r.cantidad === 1 ? "" : "s"} de {r.servicio}{r.ciudad_contacto ? ` en ${r.ciudad_contacto}` : ""}</p>
          {r.via && <p data-testid="buscar-result-via" className="text-xs c-muted">vía {r.via.nombre_publico}</p>}
        </div>
      </div>
      <div className="flex items-center justify-between gap-2">
        <span data-testid="buscar-result-level" className="text-[11px] px-2 py-0.5 rounded-full bg-[var(--c-elev)]">{lvlText}</span>
        <button data-testid="buscar-request-intro-btn" disabled={!servicio} onClick={() => setOpen(true)} className="c-btn-primary px-3.5 py-2 text-sm flex items-center gap-1.5"><HandHeart className="w-4 h-4" /> Pedir presentación</button>
      </div>
      <IntroRequestSheet open={open} onOpenChange={setOpen} r={r} servicio={servicio} ciudad={ciudad} necesidad={necesidad} />
    </div>
  );
};
